import React, { useEffect, useState } from 'react';
import { textFilter } from 'react-bootstrap-table2-filter';
import { VscNewFile, VscRefresh, VscSearch } from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import { getProjectIDTree } from '../../../../ressources/functionJS/getProjectIDTree';
import { searchKeyInTree } from '../../../../ressources/functionJS/searchKeyInTree';
import * as privilege from '../../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import { glossaire_type_de_vue } from '../../../../ressources/glossaires/glossaire_type_de_vue';
import ofF from '../../../../ressources/Logo/off-f.png';
import oN from '../../../../ressources/Logo/on-f.png';
import S from '../TableauxDeBord/TableauDeBord.module.scss';
import { updateFavoriteViewsV25 } from '../../../../services/api';
import * as actions from '../../../../services/actions';
import Bouton from '../../../UI/Bouton/Bouton';
import Popup from '../../../UI/PopupVue/Popup';
import Tableau from '../../../UI/tableau/Tableau';
import AffichageVue from '../../../Vue/AffichageVue/AffichageVue';

const Vues = ({ creer, siLaListeAUneValeur }) => {
  const dispatch = useDispatch();

  // Redux state
  const listeVues = useSelector((state) => state.vue.views_list);
  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );
  const projects_list = useSelector((state) => state.authentifie.projects_list);
  const project_id_url = useSelector(
    (state) => state.interfaceClient.project_id_url
  );
  const arborescence_projets = useSelector(
    (state) => state.interfaceClient.arborescence_projets
  );
  const favorite_views_list = useSelector(
    (state) => state.vue.favorite_views_list
  );
  const user_id = useSelector((state) => state.authentifie.user_id);

  // Local state
  const [tableauDeBord_id, setTableauDeBord_id] = useState(null);
  const [afficherPopupVue, setAfficherPopupVue] = useState(false);
  const [listeDesProjetsId, setListeDesProjetsId] = useState([]);
  const [favoriteViewIds, setFavoriteViewIds] = useState([]);

  const toggleFavoriVue = async (event, view_id) => {
    if (event) {
      event.stopPropagation();
    }
    const id = parseInt(view_id);
    setFavoriteViewIds((prev) => {
      const next = prev.includes(id)
        ? prev.filter((val) => val !== id)
        : [...prev, id];
      // appel API en tache de fond
      updateFavoriteViewsV25({
        userId: parseInt(user_id),
        favoriteViewIds: next,
      }).catch(() => {
        // rollback si erreur
        setFavoriteViewIds(prev);
      });
      return next;
    });
  };

  const [columns, setColumns] = useState([
    // liste des clés pour l'entête du tableau de vue
    {
      dataField: 'favoris',
      text: [checkMot('favoris') + ' '],
      sort: true,
      align: 'center',
      headerAlign: 'center',
      style: {
        width: '150px',
      },

      formatter: (cell, row) => {
        const isFavorite = parseInt(cell) === 1;
        return (
          <button
            type="button"
            className={S.favoriBtn}
            title={isFavorite ? 'favori' : 'Non favori'}
            onClick={(event) => toggleFavoriVue(event, row.view_id)}
          >
            <img
              alt={isFavorite ? 'on' : 'off'}
              src={isFavorite ? oN : ofF}
              className={S.favoriIcon}
            />
          </button>
        );
      },
    },
    {
      dataField: 'view_id',
      text: [
        checkMot('id'),
        <Bouton
          key={'view_id_header_search'}
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('view_id', checkMot('id'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      hidden: true,
      headerAlign: 'left',
      align: 'left',
    },
    {
      dataField: 'project_id',
      text: [
        checkMot('projet'),
        <Bouton
          key={'project_id_header_search'}
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('project_id', checkMot('projet'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      align: 'left',
      headerAlign: 'left',
      hidden: true,
      formatter: (cell) => {
        for (let i = 0; i < projects_list.length; i++) {
          if (projects_list[i].project_id === cell) {
            return projects_list[i].project_name;
          }
        }
        return cell;
      },
    },
    {
      dataField: 'view_name',
      text: [checkMot('nom') + ' '],
      sort: true,
      align: 'left',
      headerAlign: 'left',
      filter: textFilter(),
      formatter: (cell, row) => {
        return <span title={row.view_title}>{cell}</span>;
      },
    },
    {
      dataField: 'view_title',
      text: [checkMot('descriptif') + ' '],
      sort: true,
      align: 'left',
      headerAlign: 'left',
      hidden: true,
    },
  ]);

  const [selectRow] = useState({
    mode: 'radio',
    clickToSelect: true,
    hideSelectAll: true,
    hideSelectColumn: true,
    style: () => ({
      background: '#eeb214',
      color: 'black',
    }),
    onSelect: (row) => {
      ouvrirPopupVue();
      vueSelectionne(row.view_id);
    },
  });

  // Effects
  useEffect(() => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      const newListeDesProjetsId = getProjectIDTree(
        searchKeyInTree(
          { nodes: arborescence_projets },
          parseInt(project_id_url)
        )
      );
      dispatch(actions.reqRecupererListeVues(newListeDesProjetsId));
      setListeDesProjetsId(newListeDesProjetsId);
    } else if (filtre_projects_list_id.length > 0) {
      dispatch(actions.reqRecupererListeVues(filtre_projects_list_id));
    }
  }, [project_id_url, filtre_projects_list_id, arborescence_projets, dispatch]);

  // Handlers
  const afficherFiltre = (dataField, placeholder) => {
    const newCol = columns.map((col) => {
      if (col.dataField === dataField) {
        return {
          ...col,
          filter: textFilter({ placeholder }),
        };
      }
      return col;
    });
    setColumns(newCol);
  };

  const vueSelectionne = (view_id) => {
    setTableauDeBord_id(view_id);
  };

  const fermerPopupVue = () => {
    setAfficherPopupVue(false);
  };

  const ouvrirPopupVue = () => {
    setAfficherPopupVue(true);
  };

  const handleRefresh = () => {
    dispatch(actions.reqRecupererListeVues(listeDesProjetsId));
  };

  useEffect(() => {
    const initialFavorites = favorite_views_list?.map((value) => value[0]) || [];
    setFavoriteViewIds(initialFavorites);
  }, [favorite_views_list]);

  // Data processing
  const donnees_avec_favoris = listeVues.reduce((acc, vue) => {
    if (
      parseInt(vue.view_type) === glossaire_type_de_vue.plan_et_carte &&
      listeDesProjetsId.indexOf(parseInt(vue.project_id)) > -1
    ) {
      const isFavorite =
        favoriteViewIds.includes(parseInt(vue.view_id)) ||
        favorite_views_list?.some((fav) => fav[0] === vue.view_id);
      acc.push({ ...vue, favoris: isFavorite ? 1 : 0 });
    }
    return acc;
  }, []);

  if (donnees_avec_favoris.length > 0) {
    siLaListeAUneValeur(true);
  }

  return (
    <>
      <Tableau
        privilegeCreer={privilege.creer_des_vues}
        creer={creer}
        iconeCreer={<VscNewFile size={15} />}
        cleLigne={'view_id'}
        donnees={donnees_avec_favoris}
        colonnes={columns}
        selectionnerLignes={selectRow}
      >
        <AttenteRequete
          request_type={requestType.recuperation_de_la_liste_des_vues}
          str={checkMot('maj_vues_en_cour')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            type={type_btn.outil}
            rond={true}
            cliquer={handleRefresh}
          >
            <VscRefresh size={15} />
          </Bouton>
        </AttenteRequete>
      </Tableau>
      <Popup
        sansBouton={true}
        eventAuClique={ouvrirPopupVue}
        eventALaFermeture={fermerPopupVue}
        showModal={afficherPopupVue}
      >
        <AffichageVue view_id={tableauDeBord_id} />
      </Popup>
    </>
  );
};

export default Vues;
